module.exports = __webpack_public_path__ + "static/media/BCN.73115435.svg";